import { http } from "../http-common";
import { IDocumentRequest, IDocumentResponse } from "../types/Documents";
import { isAuthorized, openNotification } from "../utils";

const getAll = () => {
    return http.get<IDocumentResponse>(`/document`);

    if (isAuthorized('document.list')) {
        return http.get<IDocumentResponse>(`/document`);
    } else {
        openNotification('error', 'Başarısız', 'Yetkiniz yok.');
        return Promise.resolve(null);
    }
};


const create = (data: any, file: any) => {

    const formData = new FormData();
    formData.append("file", file);
    formData.append("title", data.title);
    formData.append("description", data.description);
    if(data?.subjectId){
        formData.append("subjectId", data.subjectId.toString());
    }
    if(data?.videoId){
        formData.append("videoId", data.videoId);
    }

    const config = {
        headers: {
            maxBodyLength: Infinity,
            'Content-Type': 'multipart/form-data',
        },
    };

    return http.post<IDocumentRequest>(`/document`, formData, config);

    if (isAuthorized('document.create')) {
        return http.post<IDocumentRequest>(`/document`, formData, config);
    } else {
        openNotification('error', 'Başarısız', 'Yetkiniz yok.');
        return Promise.resolve(null);
    }
};

const getFile = (fileName: any) => {
    return http.get<any>(`/document/download?file=${fileName}`, { responseType: 'arraybuffer' });
};

const get = (id: number) => {
    return http.get<IDocumentRequest>(`/document/${id}`);

    if (isAuthorized('document.show')) {
        return http.get<IDocumentRequest>(`/document/${id}`);
    } else {
        openNotification('error', 'Başarısız', 'Yetkiniz yok.');
        return Promise.resolve(null);
    }
};

const update = (id: number, data: IDocumentRequest) => {
    return http.patch<IDocumentRequest>(`/document/${id}`, data);

    if (isAuthorized('document.update')) {
        return http.patch<IDocumentRequest>(`/document/${id}`, data);
    } else {
        openNotification('error', 'Başarısız', 'Yetkiniz yok.');
        return Promise.resolve(null);
    }
};

const remove = (id: number) => {
    return http.delete<IDocumentRequest>(`/document/${id}`);

    if (isAuthorized('document.delete')) {
        return http.delete<IDocumentRequest>(`/document/${id}`);
    } else {
        openNotification('error', 'Başarısız', 'Yetkiniz yok.');
        return Promise.resolve(null);
    }
};

const updateSortOrders = (data: any) => {
        return http.put<any>(`/document/update-sort-orders`, data);
};

const DocumentService = {
    create,
    getAll,
    get,
    update,
    getFile,
    remove,
    updateSortOrders
}

export default DocumentService;